module.exports = __webpack_public_path__ + "img/royal_guard_small.8aee8326.png";